export const REQUESTOR = "studio";
//# sourceMappingURL=constants.js.map